import logger from 'core/utils/Logger'
import { AggregateWorkflowError } from 'onboarding/classes/errors/AggregateWorkflowError'
import { ValidationParamsError } from 'onboarding/classes/errors/ValidationParamsError'
import { showError } from 'onboarding/classes/services/notification'
import { convertErrorMessagesToHTMLList } from 'onboarding/utils/convertErrorMessagesToHTMLList'

/**
 * @param e
 * @returns unique error notification id
 */
export function showErrorOnCatch(e: any): string {
  if (e instanceof AggregateWorkflowError) {
    return showError(convertErrorMessagesToHTMLList([e.message, ...e.errors]), { autoHide: false })
  }
  if (e instanceof ValidationParamsError) {
    logger.error(e.toObject())
    return showError(convertErrorMessagesToHTMLList([e.message, ...e.getErrorsPayload()]), {
      autoHide: false,
    })
  }

  return showError(e.message, { autoHide: false })
}
